import { EOrderStatus } from '@mahawi/eshop-common/src/types';
import React from 'react';

import OrderLayout from '../../components/orders/orders-layout';

function OrdersCreatedContainer(): React.ReactElement {
  return <OrderLayout orderStatusTypeCodes={[EOrderStatus.CREATED]} />;
}

export default OrdersCreatedContainer;
